import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { BackOfficeService } from 'src/app/back-office-pages/back-office.service';
import { VariantService } from 'src/app/admin-pages/variant.service';
// import { FcmService } from 'src/app/services/fcm.service';
import { ConfigService } from 'src/app/services/config.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { menuItems } from '../menu'
import { UtilityService } from 'src/app/services/utility.service';
import { PrivilegesService } from 'src/app/services/privileges.service';

interface ToolData {
  shopName?: string;
  isShowShopName?: boolean;
  isShowShopNameFilter?: boolean;
  isShowSearch?: boolean;
  isShowCart?: boolean;
  title: string;
  isShowfilter?: boolean;
  isShowRefresh?: boolean;
  isShowRP?: boolean;
  isShowEditOrderButton?: boolean;
  isShowCancelOrder?: boolean;
  isShowReturnOrder?: boolean;
  isUserButton?: boolean;
  isTranAdd?: boolean;
  isBar?: boolean;
  isAdd?: boolean;
  addMsg?: string;
  isAddRtrn?: boolean;
  isBack?: boolean;
  isShowStockEdit?: boolean;
  isShowPriceEdit?: boolean;
  isDelete?: boolean;
  isShowDownload?: boolean;
  isShowExcelDownload?: boolean;
  isShowList?: boolean;
  productCount: number;
  isShowShare?: boolean;
  isShopFiltered?: boolean;
  ShopName?: string;
  isShopService?: boolean;
  isCall?: boolean;
  phoneNo?: string;
}

@Component({
  selector: 'app-service-near-toolbar',
  templateUrl: './service-near-toolbar.component.html',
  styleUrls: ['./service-near-toolbar.component.scss']
})
export class ServiceNearToolbarComponent {
  @Input() toolbarDetails: ToolData;
  @Output() Reload = new EventEmitter<boolean>();
  @Output() ChangeShop = new EventEmitter<boolean>();
  @Output() rp = new EventEmitter<boolean>();
  @Output() onSearchClicked = new EventEmitter<boolean>();
  @Output() onFilterClick = new EventEmitter<boolean>();
  @Output() Edit = new EventEmitter<boolean>();
  @Output() Cancel = new EventEmitter<boolean>();
  @Output() return = new EventEmitter<boolean>();
  @Output() addTran = new EventEmitter<boolean>();
  @Output() Add = new EventEmitter<boolean>();
  @Output() back = new EventEmitter<boolean>();
  @Output() StockEdit = new EventEmitter<boolean>();
  @Output() PriceEdit = new EventEmitter<boolean>();
  @Output() delete = new EventEmitter<boolean>();
  @Output() download = new EventEmitter<boolean>();
  @Output() downloadExcel = new EventEmitter<boolean>();
  @Output() sHowProducts = new EventEmitter<boolean>();

  isSearchActive: boolean = false;
  isFilterActive: boolean = false;
  selectedShop: any = { key: 0, a: 'dssdf' };
  originalUser: any;
  loginDetails: any = {};
  isApiError: boolean;
  isShowLogOutConfirm: boolean;
  shopList: any = [{ ShopName: 'All', ID: 0 }];
  CartCount: number = 0;
  selectedUser: any = {};
  isRouteUser: boolean;
  iSelectedRoute: boolean;
  loggedInUserID: number = 0;
  isShowReportList: boolean = false;

  isSuperAdmin!: boolean;
  isSelectedSuper!: boolean;
  adminDetails: any;

  isReseller!: boolean;
  shopeDomainName: any;
  appName: string;
  registrationData: any;
  isCollapsed: boolean = true;

  showBackButton: boolean = false;
  menuItemsList: any = menuItems;

  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;

  constructor(
    private router: Router,
    private backOfficeService: BackOfficeService,
    public apiService: ApiService,
    private vs: VariantService,
    // private fcmService: FcmService,
    public configService: ConfigService,
    // public modalService:ModalService
    private route: ActivatedRoute,
    private location: Location,
    private utilityService: UtilityService,
    public privilegeService: PrivilegesService,
  ) {
    this.isReseller = this.configService.isReseller;
    this.router.events.subscribe(() => {
      this.checkBackButton();
    });
  }

  ngOnInit(): void {
    this.privilegeService.getUserPrivileges();
    this.toolbarDetails.isShowShopNameFilter = true;
    this.setUpUser();

    const user = this.apiService.getSelectedUser();
    this.loggedInUserID = user?.ID ?? 0;
    this.adminDetails = this.apiService.getRealUserData();
  }

  public openSideNav() {
    document.getElementById("mySidenav").style.width = "85%";
    document.getElementById("myCloseContainer").style.width = "15%";
    document.body.style.overflow = 'hidden'; // disable background scroll
  }

  public closeSideNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("myCloseContainer").style.width = "0";
    document.body.style.overflow = ''; // restore default
  }

  public gotoPage(path) {
    if (path === '/servicenear/logout') {
      this.configService.logoutUser(false, true);
    } else {
      const currentParams = this.route.snapshot.queryParams;
      this.router.navigate([path], { queryParams: currentParams });
    }
    this.closeSideNav();
  }

  public navigateToJobDetails(itemId: any) {
    const { thirdpartyuserkey, thirdpartyappurl } = this.route.snapshot.queryParams;
    this.router.navigate(['/servicenear/serviceDetails'], { queryParams: { workID: itemId, thirdpartyuserkey, thirdpartyappurl } });
  }

  showReports(event: boolean) {
    if (this.isShowReportList === false) {
      this.isShowReportList = true;
    } else {
      this.isShowReportList = false;
    }
  }

  public routeToServicenear() {
    const thirdPartyAppUrl = this.utilityService.getParamValueFromAnyUrl('thirdpartyappurl');
    const thirdPartyLogoutURl = thirdPartyAppUrl + '/?activateoldui=true';
    window.location.href = thirdPartyLogoutURl;
  }

  public logOutClicked() {
    this.configService.isShowLogOutConfirm = true;
    this.closeSideNav();
    // this.modalService.open(logoutTemplate, false, this.isShowLogOutConfirm);
  }

  ActivateSearch() {
    this.isSearchActive = !this.isSearchActive;
    this.onSearchClicked.emit(this.isSearchActive);
  }

  public filterClick() {
    // this.isFilterActive = !this.isFilterActive;
    // this.onFilterClick.emit(this.isFilterActive)
    this.onFilterClick.emit(true);
  }

  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      const currentParams = this.route.snapshot.queryParams;
      this.router.navigate(['/servicenear/dashboard'], { queryParams: currentParams });
    }
  }

  public clearUserSelection() {
    this.backOfficeService.clearCustomerSelection();
    this.setUpUser();
    this.gotoPage('/user/userlist');
  }

  private setUpUser() {
    this.selectedUser = this.apiService.getSelecterUserData();
    this.originalUser = this.apiService.getRealUserData();

    this.isRouteUser = this.originalUser?.UserType === 'admin' ? true : false; //removed soon
    this.iSelectedRoute =
      this.selectedUser?.UserType === 'admin' ? true : false; //removed soon

    this.isSuperAdmin =
      this.originalUser.UserType == 'superadmin' ? true : false;
    this.isSelectedSuper =
      this.selectedUser.UserType == 'superadmin' ? true : false;
  }

  public gotoAddProduct() {
    if (this.isReseller) {
      this.router.navigate(['/Reseller/AddProduct']);
    } else {
      if (location.hash.split('/')[2] == "product-edit") {
        this.vs.initVariantService(0);
      }
      this.router.navigate(['/products/product-edit', 0]);
    }
    this.closeSideNav();
  }

  ShareMyStore() {
    const shopeDomainName = this.configService.getLoginDetails()?.SubDomain;
    const appName = environment.appName.toLowerCase();
    const shareableLink = `https://${shopeDomainName}`;

    if (shopeDomainName && appName) {
      if (navigator.share) {
        navigator.share({
          title: 'Share My Store',
          text: 'Check out my store',
          url: shareableLink,
        }).catch((error) => {
          console.error('Sharing failed:', error);
        });
      }
    } else {

    }
    this.closeSideNav();
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  checkBackButton() {
    const currentUrl = this.router.url;
    this.showBackButton = !currentUrl.startsWith('/servicenear/dashboard');
  }

  callNumber(number: string) {
    if (number) {
      window.location.href = `tel:${number}`;
    } else {
      console.warn('No phone number provided');
      this.notify(false, 'No phone number provided');
    }
  }

  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 2000);
  }

}
